import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import TradeHubFeatures from "./TradeHubFeatures";
import TradeHubBenefits from "./TradeHubBenefits";
// TradeHubStack Component - Provides an overview of TradeHub features and functionalities

export default function TradeHubStack() {
  // Section: Features of TradeHubStack
  const data1 = [
    "Contract Manufacturing: Allows buyers to submit RFQ (Request for Quotation) and order requests to sellers for processed or semi-processed products, optionally specifying a time frame for delivery.",
    "Contract Farming: Enables buyers to submit RFQ (Request for Quotation) and order requests to sellers for assets or raw products, with an optional time frame for delivery.",
    "Retail Order Management: Buyers can purchase any type of agricultural product, whether raw, processed, or semi-processed, and send a request to the seller.",
    "Agri Asset Management: Facilitates Agri Asset Investment, allowing investors to explore available white-label assets and invest in them, providing diversification within the agricultural industry.",
  ];

  // Section: Backend and Security Features
  const data2 = [
    "Beckn API: TradeHub backend network-based API implemented to achieve decentralized and P2P architecture, ensuring wider interoperability among agrifood ecosystem players.",
    "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
    "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
  ];

  return (
    <>
      {/* Section: Header Banner */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["TradeHub Stack"]}
        bannerbodycopy="Contract Farming | Contract Manufacturing | Buy and Sell | Investment "
      />

      {/* Section: Overview */}
      <SolutionEcosystem title="Overview" type="TradeHub" />

      {/* Section: Feature Highlights */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Section: Additional Features */}
      <TradeHubFeatures />

      {/* Section: Benefits */}
      <TradeHubBenefits />

      {/* Section: Call to Action */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software?"
        />
      </Container>
    </>
  );
}
